import { render } from "./BetGroup.vue?vue&type=template&id=45d4e157&scoped=true&ts=true"
import script from "./BetGroup.vue?vue&type=script&lang=ts"
export * from "./BetGroup.vue?vue&type=script&lang=ts"

import "./BetGroup.vue?vue&type=style&index=0&id=45d4e157&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\new2h5\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d4e157"]])

export default __exports__